import { render, staticRenderFns } from "./TFWHeader.vue?vue&type=template&id=5bdcb3b8"
import script from "./TFWHeader.vue?vue&type=script&lang=js"
export * from "./TFWHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports